/**
 * StatisticService.js
 *
 * Provides a function to fetch statistics by year or for all years.
 * Uses the generic API utility for HTTP requests.
 */

import { GET } from '@/shared/constants/httpMethods';
import { api } from '../httpCall';

/**
 * Fetches statistics for a specific year or for all years.
 * @param {string|number} year - The year to fetch statistics for, or 'All' for all years.
 * @returns {Promise<any>} The statistics data.
 */
export const getStatisticsByYear = async (year) => {
  let selectedYearParams = '';

  if (year === 'All') {
    // List of all years to include in the query
    const decodeYears = [2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018];
    for (let i = 0; i < decodeYears.length; i += 1) {
      selectedYearParams += i === 0 ? `year=${decodeYears[i]}` : `&year=${decodeYears[i]}`;
    }
  } else {
    selectedYearParams = `year=${year}`;
  }

  // Await the API call for proper error handling
  const response = await api(GET, `/admin/stats?${selectedYearParams}`);
  return response;
};
